/*
 * Karl's six moods as the compact 64 px set shared with the web portal. The
 * loops are VP9 WebM with alpha; the stills are frame one, used for reduced
 * motion and as the video fallback. Each state is a plain public path so only
 * the mood on screen is fetched.
 */
import type { KarlConfidenceLevel } from "../state/types";

export type KarlAvatarState = "idle" | "thinking" | "sure" | "uncertain" | "done" | "cant";

export interface KarlAvatarMedia {
  loop: string;
  still: string;
}

const base = "/assets/karl";
const media = (state: KarlAvatarState): KarlAvatarMedia => ({
  loop: `${base}/karl-${state}-64.webm`,
  still: `${base}/karl-${state}-64.png`,
});

export const KARL_AVATAR_MEDIA: Record<KarlAvatarState, KarlAvatarMedia> = {
  idle: media("idle"),
  thinking: media("thinking"),
  sure: media("sure"),
  uncertain: media("uncertain"),
  done: media("done"),
  cant: media("cant"),
};

/*
 * Only a Sure verdict gets the confident owl. Likely and Uncertain share the
 * uncertain portrait; the badge beside it already names the exact Confidence.
 */
export const karlAvatarStateForConfidence = (level: KarlConfidenceLevel): KarlAvatarState =>
  level === "sure" ? "sure" : "uncertain";
